import styles from './mannschaftssportpage.module.css';
import TeamCard from '../../../components/TeamCard/TeamCard';
import HeroBanner from '../../../components/HeroBanner/HeroBanner';
import { useState } from 'react';
import { badminton, basketball, fussball, volleyball } from '../../../../code/unsplashImages';
function MannschaftssportPage() {
    const [hasImages, setHasImages] = useState(false);
    const abteilung = [
        {
            "team": "Badminton",
            "link": "/mannschaftssport/badminton",
            "img": badminton.path,
            "altText": badminton.altText
        },
        {
            "team": "Basketball",
            "link": "/mannschaftssport/basketball",
            "img": basketball.path,
            "altText": basketball.altText
        },
        {
            "team": "Fußball",
            "link": "/mannschaftssport/fußball",
            "img": fussball.path,
            "altText": fussball.altText
        },
        {
            "team": "Volleyball",
            "link": "/erlebnissport/sport-und-natur#beach-arena",
            "img": volleyball.path,
            "altText": volleyball.altText
        },
    ]
    return (
        <div>
            <HeroBanner category="mannschaftssport" onImagesLoaded={setHasImages} />
            <section className={styles.container} style={{ marginTop: hasImages ? '20px' : 'var(--marginTopDefault)' }} >
                <h1>Mannschaftssport</h1>
                <p>Hier gibt’s alle Informationen rund um die Abteilungen:<br />Ob Trainingszeiten, Kursdauer, das neuste Mannschaftsfoto, Spielberichte oder Kontaktdaten der Trainer – bei der jeweiligen Abteilung finden Sie alles was Sie wissen wollen.</p>
                <div className={styles.abteilungen}>
                    {abteilung.map((item, index) => (
                        <TeamCard key={index} item={item} />
                    ))}
                </div>
            </section>

        </div >
    );
}

export default MannschaftssportPage;